module.exports = __webpack_public_path__ + "static/head-avatar-077de6be6a5fa89c881db7d22fbdbbf3.jpg";